import API from "./API";

export default class Statistics extends API
{
    static async getStatistics() {
        return this.get("api/admin/statistics");
    }
    
    
}